import React from 'react';
import { useHorario } from '../HorarioContext';

export default function EstadoAbierto() {
    const { abierto, mensaje, loading } = useHorario();

    if (loading) return null;

    if (!abierto) {
        return (
            <div className='estadoAbierto estadoCerrado'>
                <span className='estadoDotPulso' />
                <span className='estadoTextoEstado'>Cerrado</span>
                <span className='estadoMensajeEstado'>{mensaje}</span>
            </div>
        );
    }

    return (
        <div className='estadoAbierto'>
            <span className='estadoDot' style={{ background: '#22c55e' }} />
            <span className='estadoTexto'>Abierto</span>
            <span className='estadoMensaje'>{mensaje}</span>
        </div>
    );
}
